import type { Ref } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { getSafeJSONValue, setSafeJSONValue } from '@app/utils/local-storage'

export default function usePresentationComments(): {
  presentationComments: Ref<string[]>
  commentAdded: (commentId: string) => void
  commentRemoved: (commentId: string) => void
} {
  const presentationComments = ref<string[]>(
    getSafeJSONValue('presentationComments') || []
  )

  function commentAdded(commentId: string): void {
    presentationComments.value = presentationComments.value || []
    presentationComments.value.push(commentId)
    setSafeJSONValue('presentationComments', presentationComments.value)
  }

  function commentRemoved(commentId: string): void {
    presentationComments.value = presentationComments.value || []
    const index = presentationComments.value.indexOf(commentId)
    if (index !== -1) {
      presentationComments.value.splice(index, 1)
    }
    setSafeJSONValue('presentationComments', presentationComments.value)
  }

  onMounted(() => {
    window.eventHub.$on('postComment', commentAdded)
    window.eventHub.$on('removeComment', commentRemoved)
  })

  onUnmounted(() => {
    window.eventHub.$off('postComment', commentAdded)
    window.eventHub.$off('removeComment', commentRemoved)
  })

  return {
    presentationComments,
    commentAdded,
    commentRemoved,
  }
}
